import Route from '../../src/Route';

const state = {
  user: null,
  loading: false,
};

const mutations = {
  SET_USER_DETAILS(state, user) {
    state.user = user;
  },
  UPDATE_LOADING(state, getting) {
    state.loading = getting;
  },
};

const actions = {
  GET_USER_DETAILS({ commit }) {
    commit('UPDATE_LOADING', true);

    axios
      .get(Route('json.user'))
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER_DETAILS', response.data.user);
        } else {
          throw 'Failed to get user details.';
        }
      })
      .catch((error) => {
        commit('UPDATE_ERROR', error);
      })
      .then(() => {
        commit('UPDATE_LOADING', false);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
